import { render, staticRenderFns } from "./_tag.vue?vue&type=template&id=ddad0b36"
import script from "./_tag.vue?vue&type=script&lang=js"
export * from "./_tag.vue?vue&type=script&lang=js"
import style0 from "./_tag.vue?vue&type=style&index=0&id=ddad0b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_tag.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports